/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbSyncProgress {
    getFixupPrototypeFunction() { return ServiceNowCmdbSyncProgress.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbSyncProgress>): ServiceNowCmdbSyncProgress {
        let obj = Object.assign(new ServiceNowCmdbSyncProgress(), model);
        ServiceNowCmdbSyncProgress.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbSyncProgress>): ServiceNowCmdbSyncProgress {
        if (!model) return null;
        return ServiceNowCmdbSyncProgress.newInstance(<ServiceNowCmdbSyncProgress> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbSyncProgress) {
        if (!obj) return;

        models.ServiceNowCmdbSyncProgress.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbSyncProgress): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbSyncProgress.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total === undefined) {
            this.total = 0;
        }
        if (this.success === undefined) {
            this.success = 0;
        }
        if (this.failed === undefined) {
            this.failed = 0;
        }
    }

    /**
     * Total number of resources identified for ServiceNow Cmdb sync
     */
    total: number;

    /**
     * Number of resources that have been synced
     */
    success: number;

    /**
     * Number of resources that have been failed to sync
     */
    failed: number;

}
